/**
 * @generated SignedSource<<22e634102824e5d14683a084eb395c43>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CourseColumns_facilities$data = ReadonlyArray<{
  readonly agendas: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly queueSlot: {
          readonly id: string;
        };
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly courses: {
    readonly count: number;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
        readonly " $fragmentSpreads": FragmentRefs<"SingleCourseColumn_course">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"useGetFirstLastTimeAcrossCoursesPatron_facilities">;
  readonly " $fragmentType": "CourseColumns_facilities";
}>;
export type CourseColumns_facilities$key = ReadonlyArray<{
  readonly " $data"?: CourseColumns_facilities$data;
  readonly " $fragmentSpreads": FragmentRefs<"CourseColumns_facilities">;
}>;

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "courseIds"
    },
    {
      "kind": "RootArgument",
      "name": "date"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "CourseColumns_facilities",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useGetFirstLastTimeAcrossCoursesPatron_facilities"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "courseIds",
          "variableName": "courseIds"
        }
      ],
      "concreteType": "CourseConnection",
      "kind": "LinkedField",
      "name": "courses",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CourseEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Course",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "SingleCourseColumn_course"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "dateGte",
          "variableName": "date"
        },
        {
          "kind": "Variable",
          "name": "dateLte",
          "variableName": "date"
        }
      ],
      "concreteType": "AgendaConnection",
      "kind": "LinkedField",
      "name": "agendas",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AgendaEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Agenda",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "QueueSlot",
                  "kind": "LinkedField",
                  "name": "queueSlot",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Facility",
  "abstractKey": null
};
})();

(node as any).hash = "264e5824accb7b1d1c1b967f49a43d56";

export default node;
